<app-form-page 
    pageTitle="Form Page Test" 
    [mode]="mode"
    [allowEditMode]="true"
    [allowNewMode]="true"
    [form]="tForm"
    (modeChanged)="onModeChanged($event)"
    >

    <app-page-command-group>
        <app-page-command name="edit" [action]="onEditClick"></app-page-command>
        <app-page-command name="new" [action]="onNewClick"></app-page-command>
        <app-page-command name="save" [action]="onSaveClick"></app-page-command>
        <app-page-command name="cancel" [action]="onCancelClick"></app-page-command>
        <app-page-command name="my-custom1" text="Start" icon="dx-icon-runner" [action]="onCustomClick" requiredPermissions="my-custom-permission, my-admin-permission"></app-page-command>
    </app-page-command-group>

    <!-- Place your content here -->
    <form #tForm="ngForm">
        <app-layout-row>
            <app-layout-column [width]="8">
                <app-textbox decorator [ngModel]="name" name="name" caption="Name" required></app-textbox>
            </app-layout-column>
        </app-layout-row>
    </form>

    <p>Mode is: {{mode.toString()}}</p>
</app-form-page>

